import { requestConfig } from "../config.js";

/**
 * Получить перечень неподписанных документов
 *
 * @param {Number} contractId
 * @param {String} billingId
 */
export async function apiFetchUnsignedDocumentList(contractId, billingId) {
  const response = await requestConfig.get("/api/v0/agreement_conclusion/unsigned_contract/", {
    params: {
      contract_id: contractId,
      billing_id: billingId,
    },
  });

  return response.data?.detail?.documents;
}

/**
 * Получить перечень подписанных документов
 *
 * @param {Number} contractId
 * @param {String} billingId
 */
export async function apiFetchSignedDocumentList(contractId, billingId) {
  const response = await requestConfig.get("/api/v0/agreement_conclusion/signed_contract/", {
    params: {
      contract_id: contractId,
      billing_id: billingId,
    },
  });

  return response.data?.detail?.documents;
}
